var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemHealth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H19.9883C24.4066 0 27.9883 3.58172 27.9883 8V19.9883C27.9883 24.4066 24.4066 27.9883 19.9883 27.9883H8C3.58172 27.9883 0 24.4066 0 19.9883V8Z",
    fill: "#057DCD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_2145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3262 7.99561H8.66211C7.92591 7.99561 7.3291 8.59241 7.3291 9.32861V15.9937C7.3291 16.7299 7.92591 17.3267 8.66211 17.3267H19.3262C20.0624 17.3267 20.6592 16.7299 20.6592 15.9937V9.32861C20.6592 8.59241 20.0624 7.99561 19.3262 7.99561Z",
    stroke: "white",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 19.9927H16.6602",
    stroke: "white",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 17.3267V19.9927",
    stroke: "white",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_2145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9961,
    height: 15.9961,
    fill: "white",
    transform: "translate(5.99609 5.99609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemHealth);
export default __webpack_public_path__ + "static/media/SystemHealth.718e1612027bb3007f5fa27c24185d1f.svg";
export { ForwardRef as ReactComponent };